import CommonSlice from "./common.reducer";

export default {
    Common:CommonSlice.reducer,
}